import { INPUT_ACTION_KEY } from "../constant";
const initial_state = {
  selectedData: {},
};
const InputReducer = (state = initial_state, action) => {
  switch (action.type) {
    case INPUT_ACTION_KEY:
      return { ...state, selectedData: { ...action.payload } };
    default:
      return state;
  }
};
export default InputReducer;
